import { Badge, Box, Grid, Typography } from "@mui/material"
import StatusComponent from "../../../../../../../../../../components/status"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { DetailAndUploadOfEvidences } from "../../../../../../../../../../components/detailAndUploadOfEvidences"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../../../../utils/icons"
import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { useEffect, useRef, useState } from "react"
import { PropsActivityWithGeofence } from "./types"
import { ViewEvidence } from "../../../../../../../../../../components/detailAndUploadOfEvidences/enum"
import { Status } from "../../../../../../../../../../utils/enums"
import { formatEvidenceToUploadEvidence } from "../../../../../../../../../../components/uploadEvidence/methods"



const ActivityWithGeofence = (props: PropsActivityWithGeofence) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const drawerRef = useRef<{ closeDrawer?: () => void }>({});
    const [view, setView] = useState<ViewEvidence>(ViewEvidence.DETAIL)
    const { defaultEvidence, evidencesDrawer, setDeletedsEvidencesList, setEvidencesDrawer, setEvidencesRequiredAreLoad, } = props.evidenceUpload

    const validateCanUpload = () => {
        if (props.status == Status.STARTED) {
            setView(ViewEvidence.EDIT)
            const response = formatEvidenceToUploadEvidence({ evidenceConfig: props.evidenceConfig?.evidence, evidencesDetail: props.evidences })
            setEvidencesRequiredAreLoad({ ...props.evidenceConfig?.requireList })
            defaultEvidence({ evidencesConfig: response })
        }
    }

    useEffect(() => {

        if (!props.dataActivity?.typeOfActivity && props.dataActivity?.open) {
            const { open, ...rest } = props.dataActivity;
            props.handleDataActivity(rest);
        }

        if (props.dataActivity?.typeOfActivity?.openField) {
            props.setInputLastActivity((prevInput) => ({
                open: props.openField,
                ...prevInput,
            }));
        } else {
            props.setInputLastActivity((prevInput) => {
                const { open, ...rest } = prevInput;
                return rest;
            });
        }
    }, [props.dataActivity?.typeOfActivity]);

    return (
        <Box sx={styles.body}>
            <Box sx={styles.header}>
                <Typography sx={styles.title} variant="title_grey_dark">{t('loogbook.titles.editActivity')}</Typography>
                <StatusComponent type="chip" size="small" color={props.statusLocale.color} msg={props.statusLocale.text} />
            </Box>

            <Box>
                <Box className="mb">
                    <DinamicForm input={Object.values(props.inputActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                </Box>

                <Grid container spacing={1} className="mb">
                    <Grid item xs={11}>
                        <DinamicForm input={Object.values(props.inputSecondActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                    </Grid>

                    <Grid item xs={1}>
                        <Box sx={styles.containerClip}>
                            <DetailAndUploadOfEvidences
                                Node={({ payload: { openDrawer, closeDrawer } }) => {
                                    /* setDrawerHandlers({ closeDrawer }); */
                                    drawerRef.current.closeDrawer = closeDrawer;
                                    return (
                                        <Badge sx={styles.badge} badgeContent={props.badgeContent}>
                                            <CustomeIconButton
                                                title={view == ViewEvidence.DETAIL ? t('general.seeEvidence') : t('loogbook.titles.chargeEvidence')}
                                                icon={icons('clip')}
                                                iconButtonProps={{
                                                    disabled: props.disabledButton,
                                                    /* color: 'primary', */
                                                    sx: styles.clip(props.disabledButton),
                                                    onClick: () => {
                                                        setDeletedsEvidencesList([])
                                                        openDrawer()
                                                        validateCanUpload()
                                                    }
                                                }} />
                                        </Badge>
                                    )
                                }}
                                view={view}
                                save={() => {
                                    props.getEvidence({ evidences: evidencesDrawer });
                                    /* if (drawerHandlers.closeDrawer) {
                                        drawerHandlers.closeDrawer();
                                    } */
                                    if (drawerRef.current.closeDrawer) {
                                        drawerRef.current.closeDrawer();
                                    }
                                }}
                                detail={{
                                    evidences: {
                                        image: props.evidences?.images,
                                        comment: props.evidences?.comments,
                                        documents: props.evidences?.documents,
                                        video: props.evidences?.video,
                                    },
                                    existEvidences: props.existEvidences
                                }}
                                upload={{
                                    evidencesDrawer,
                                    deletedEvidence: ({ name }) => { setDeletedsEvidencesList(prev => [...prev, name]) },
                                    fakeDelete: true,
                                    close: () => { },
                                    setEvidencesDrawer,
                                    setEvidencesRequiredAreLoad,
                                    uploadName: `logbook/${props.activityId}`,
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>

                <DinamicForm input={Object.values(props.inputLastActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
            </Box>
        </Box>
    )
}

export { ActivityWithGeofence }